import { render, staticRenderFns } from "./ClientConfigOptions.vue?vue&type=template&id=566fde27"
import script from "./ClientConfigOptions.vue?vue&type=script&lang=js"
export * from "./ClientConfigOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports